import { useEffect } from 'react';
import { generateBrandPalette } from '../theme/brandColorScale';

const STYLE_ID = 'brand-overrides';

function buildCssBlock(palette, prefix) {
  return [
    `--mui-palette-${prefix}-main: ${palette.main};`,
    `--mui-palette-${prefix}-light: ${palette.light};`,
    `--mui-palette-${prefix}-dark: ${palette.dark};`,
    `--mui-palette-${prefix}-contrastText: ${palette.contrastText};`,
    `--mui-palette-${prefix}-mainChannel: ${palette.mainChannel};`,
    `--mui-palette-${prefix}-lightChannel: ${palette.lightChannel};`,
    `--mui-palette-${prefix}-darkChannel: ${palette.darkChannel};`,
  ].join('\n  ');
}

function buildStyleSheet(primaryColor, secondaryColor) {
  const lightRules = [];
  const darkRules = [];

  if (primaryColor) {
    const p = generateBrandPalette(primaryColor);
    lightRules.push(buildCssBlock(p, 'primary'));
    darkRules.push(buildCssBlock(p.darkMode, 'primary'));
  }

  if (secondaryColor) {
    const s = generateBrandPalette(secondaryColor);
    lightRules.push(buildCssBlock(s, 'secondary'));
    darkRules.push(buildCssBlock(s.darkMode, 'secondary'));
  }

  if (lightRules.length === 0) return null;

  return [
    `:root, .light {\n  ${lightRules.join('\n  ')}\n}`,
    `.dark {\n  ${darkRules.join('\n  ')}\n}`,
  ].join('\n');
}

export default function ThemeBranding({ primaryColor, secondaryColor }) {
  useEffect(() => {
    const css = buildStyleSheet(primaryColor, secondaryColor);

    // Remove existing overrides
    const existing = document.getElementById(STYLE_ID);
    if (existing) existing.remove();

    if (!css) return;

    // Inject new overrides
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    document.head.appendChild(style);

    return () => {
      const el = document.getElementById(STYLE_ID);
      if (el) el.remove();
    };
  }, [primaryColor, secondaryColor]);

  return null;
}
